<template>
  <div class="app-evn-bills-overview">
  <div class="costs">
    <div>
      <strong>Kosten (Verbindungen, Nachrichten & Dienste) im Monat {{lastMonthName}} : {{costsLastMonth}} </strong><br>
      <strong>Kosten (Verbindungen, Nachrichten & Dienste) im aktuellen Monat: {{costsCurrentMonth}} </strong>
    </div>
  </div>
  <slot name="infoEVN">Hier finden Sie Ihre aktuellen Einzelverbindungen der letzten 80 Tage, die bis zum Vortag getätigt wurden. Bitte beachten Sie, dass die Angaben im Einzelverbindungsnachweis für die Abrechnung nicht maßgeblich sind, da ggf. eine verspätete Meldung durch den Netzbetreiber erfolgen kann.</slot>
  <div class="date-picker-wrapper">
    <b-form>
      <b-form-group class="date-group" label="Zeitraum auswählen" label-class="visually-hidden">
        <b-row>
          <b-col class="date-picker">
            <b-form-group :label-for="'fromData' + _uid"
                          label-cols="auto"
                          label="von:">
              <DatePicker
                :id="'fromData' + _uid"
                @input="$v.filterStartDate.$touch"
                :valid="isValid('filterStartDate')"
                :date.sync="filterStartDate"
                name="startDate"
                :disabled="loading"
                :calendar-options="{min: minDate }"
              ></DatePicker>
            </b-form-group>
          </b-col>
          <b-col class="date-picker">
            <b-form-group :label-for="'toData' + _uid"
                          label-cols="auto"
                          label="bis:">
              <DatePicker
                :id="'toData' + _uid"
                @input="$v.filterEndDate.$touch"
                :valid="isValid('filterEndDate')"
                :date.sync="filterEndDate"
                name="endDate"
                :disabled="loading"
              ></DatePicker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
    <Stepper
      @next="refreshQuery()"
      @prev="downloadEvn()"
      :loading-next="loading"
    >
      <template #btnNext>
        <slot name="btnNext"></slot>
      </template>
      <template #btnPrev>
        <slot name="btnPrev"></slot>
      </template>
    </Stepper>
  </div>
  <itemised-billing-list :list-type="'simple'" :itemised-bill-group="splittedItemisedBills.national" tag="div">
    <template #headline>
      <div class="col headline_col1">Verbindungen innerhalb Deutschlands</div><div class="col headline_col2">{{ displayCountEntries(splittedItemisedBills.national) }}</div>
    </template>
  </itemised-billing-list>
  <itemised-billing-list :list-type="'simple'" :itemised-bill-group="splittedItemisedBills.ausland" tag="div">
    <template #headline>
      <div class="col headline_col1">Verbindungen von Deutschland ins Ausland</div><div class="col headline_col2">{{ displayCountEntries(splittedItemisedBills.ausland) }}</div>
    </template>
  </itemised-billing-list>
  <itemised-billing-list :list-type="'simple'" :itemised-bill-group="splittedItemisedBills.roaming" tag="div">
    <template #headline>
      <div class="col headline_col1"><slot name="itemisedBillingListRoaming">Verbindungen im Ausland (Roaming)</slot></div><div class="col headline_col2">{{ displayCountEntries(splittedItemisedBills.roaming) }}</div>
    </template>
  </itemised-billing-list>
  <itemised-billing-list :list-type="'other'" :itemised-bill-group="splittedItemisedBills.other" tag="div">
    <template #headline>
      <div class="col headline_col1">Sonstiges</div><div class="col headline_col2">{{ displayCountEntries(splittedItemisedBills.other) }}</div>
    </template>
  </itemised-billing-list>
  <itemised-billing-list :list-type="'topUpAndVoucher'" :itemised-bill-group="splittedItemisedBills.topupAndVoucher" tag="div">
    <template #headline>
      <div class="col headline_col1">Aufladungen und Gutschriften</div><div class="col headline_col2">{{ displayCountEntries(splittedItemisedBills.topupAndVoucher) }}</div>
    </template>
  </itemised-billing-list>
  </div>
</template>
<script>
import Stepper from '../../../../generic/Stepper.vue'
import isValid from '../../../../../mixins/isValid'
import extraData from '../../../../../mixins/extraData'
import ItemisedBillingList from './ItemisedBillingList.vue'
import preFilledInput from '../../../../../mixins/preFilledInput'
import { validationMixin } from 'vuelidate'
import transaction from '../../../../../mixins/transaction'
import DatePicker from '../../../../generic/DatePicker.vue'
import { isSameOrAfter, validDate, validDateFormat, validDatePeriod } from '@/validators/date'
import { required } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapGetters } from 'vuex'
import axios from 'axios'
import FileSaver from 'file-saver'

const _Today = new Date()
const _FirstOfMonth = new Date()
_FirstOfMonth.setDate(1)

export default {
  name: 'EVNBillsOverview',
  components: {
    Stepper,
    ItemisedBillingList,
    DatePicker
  },
  data () {
    return {
      splittedItemisedBills: {
        all: [],
        national: [],
        sms: [],
        mms: [],
        ausland: [],
        roaming: [],
        topupAndVoucher: [],
        lastMonth: [],
        currentMonth: [],
        other: []
      },
      currentCustomer: {
        contract: {
          msisdn: ''
        },
        itemisedBills: {
        }
      },
      loading: false,
      downloadPending: false
    }
  },
  mixins: [
    preFilledInput('filterStartDate', 'firstOfMonth'),
    preFilledInput('filterEndDate', 'today'),
    validationMixin,
    isValid,
    extraData(),
    transaction('itemisedBills')
  ],
  validations () {
    return {
      filterStartDate: {
        validDate,
        validDatePeriod: validDatePeriod(80),
        validDateFormat,
        required
      },
      filterEndDate: {
        validDate,
        validDatePeriod: validDatePeriod(80),
        validDateFormat,
        afterStartDate: (endDate, vm) => {
          const startDate = vm.filterStartDate
          return isSameOrAfter(startDate, endDate)
        },
        required
      }
    }
  },
  methods: {
    refreshQuery () {
      this.loading = true
      this.$apollo.queries.currentCustomer.refetch({
        filter: this.getFilter()
      }).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getFilter () {
      return {
        from: this.filterStartDate,
        to: this.filterEndDate
      }
    },
    currencyFormatter: function (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(value)
    },
    $_resetSplittedItemisedBills () {
      this.splittedItemisedBills.all = []
      this.splittedItemisedBills.national = []
      this.splittedItemisedBills.roaming = []
      this.splittedItemisedBills.sms = []
      this.splittedItemisedBills.mms = []
      this.splittedItemisedBills.ausland = []
      this.splittedItemisedBills.other = []
      this.splittedItemisedBills.topupAndVoucher = []
      this.splittedItemisedBills.lastMonth = []
      this.splittedItemisedBills.currentMonth = []
    },
    $_filterCDR (bill) {
      if (bill.fromCountry === 'DE' && bill.toCountry === 'DE') {
        this.splittedItemisedBills.national.push(bill)
      } else if (bill.fromCountry === 'DE' && bill.toCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      } else if (bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterSMS (bill) {
      if (bill.fromCountry === 'DE' && bill.toCountry === 'DE') {
        this.splittedItemisedBills.national.push(bill)
      } else if (bill.fromCountry === 'DE' && bill.toCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      } else if (bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterMMS (bill) {
      if (bill.fromCountry === 'DE' && bill.toCountry === 'DE') {
        this.splittedItemisedBills.national.push(bill)
      } else if (bill.fromCountry === 'DE' && bill.toCountry !== 'DE') {
        this.splittedItemisedBills.ausland.push(bill)
      } else if (bill.fromCountry !== 'DE') {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterGPR (bill) {
      if (bill.value !== 0 && bill.value !== null && bill.fromCountry !== 'DE' && bill.fromCountry !== null) {
        this.splittedItemisedBills.roaming.push(bill)
      }
    },
    $_filterSRV (bill) {
      if (bill.groupKey !== 'ABO' && bill.groupKey !== 'RCS' && bill.value !== 0) {
        bill.descriptionServices = this.extraData.descriptionServices[bill.groupKey]
        this.splittedItemisedBills.other.push(bill)
      }
    },
    $_filterSSR (bill) {
      if (bill.groupKey !== 'ABO' && bill.value !== 0) {
        bill.descriptionServices = this.extraData.descriptionServices[bill.groupKey]
        this.splittedItemisedBills.other.push(bill)
      }
    },
    $_filterCDT (bill) {
      // Aufladungen und Gutschriften
      bill.descriptionTopUps = this.extraData.descriptionTopUps[bill.groupKey]
      this.splittedItemisedBills.topupAndVoucher.push(bill)
    },
    $_isCostAddabel (bill) {
      return bill.typeKey !== 'CDT' &&
        bill.groupKey !== 'ABO' &&
        bill.typeKey !== 'INF' &&
        bill.groupKey !== 'RCS'
    },
    $_addCosts (bills) {
      if (this.$_isCostAddabel(bills)) {
        if (new Date(bills.actionDate).getMonth() === _Today.getMonth() - 1) {
          this.splittedItemisedBills.lastMonth.push(bills)
        } else if (new Date(bills.actionDate).getMonth() === _Today.getMonth()) {
          this.splittedItemisedBills.currentMonth.push(bills)
        }
      }
    },
    $_filterItemisedBills () {
      const bills = this.currentCustomer?.itemisedBills
      this.$_resetSplittedItemisedBills()
      if (bills) {
        bills.forEach((bill, index) => {
          this.$_addCosts(bill)
          switch (bill.typeKey) {
            case 'CDR':
              this.$_filterCDR(bill)
              break
            case 'SMS':
              this.$_filterSMS(bill)
              break
            case 'MMS':
              this.$_filterMMS(bill)
              break
            case 'GPR':
            case 'GPRS':
              this.$_filterGPR(bill)
              break
            case 'CDT':
              this.$_filterCDT(bill)
              break
            case 'SRV':
              this.$_filterSRV(bill)
              break
            case 'SSR':
              this.$_filterSSR(bill)
              break
            case 'INF':
              break
          }
        })
      }
    },
    displayCountEntries (list) {
      return list.length >= 1 ? (list.length < 2 ? '1 Eintrag' : `${list.length} Einträge`) : ''
    },
    downloadEvn: function () {
      if (!this.downloadPending || this.btnAlreadyClicked) {
        this.downloadPending = true
        const me = this
        axios.get('api/document/' + this.filterStartDate + '/' + this.filterEndDate, {
          baseURL: this.$config.apiUrl || '',
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
            Accept: 'text/csv'
          },
          responseType: 'blob'
        }).then((response) => {
          const file = new Blob([response.data], { type: response.headers['content-type'] })
          FileSaver.saveAs(file, 'EVN-Zusammenfassung ' + this.filterStartDate + '-' + this.filterEndDate + '.csv')
          this.downloadPending = false
        }).catch((reason) => {
          me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
          this.downloadPending = false
        })
      }
    }
  },
  props: {
    btnAlreadyClicked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    lastMonthName () {
      const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
      ]
      return monthNames[_Today.getMonth() - 1] || 'Dezember'
    },
    costsLastMonth () {
      return this.currencyFormatter(this.splittedItemisedBills.lastMonth.map(e => e.value / 10000).reduce((a, b) => a + b, 0))
    },
    costsCurrentMonth () {
      return this.currencyFormatter(this.splittedItemisedBills.currentMonth.map(e => e.value / 10000).reduce((a, b) => a + b, 0))
    },
    minDate () {
      const mindate = new Date()
      mindate.setDate(mindate.getDate() - 80)
      return mindate
    },
    today () {
      return this.$config.calendar.formatter.dateFormatter.format(_Today)
    },
    firstOfMonth () {
      return this.$config.calendar.formatter.dateFormatter.format(_FirstOfMonth)
    }
  },
  apollo: {
    currentCustomer: function () {
      const me = this
      me.loading = true
      return wrapQuery(
        gql`query itemisedBills ($filter: ItemisedBillFilterInput){
        currentCustomer {
          contract {
            msisdn
          }
          itemisedBills(filter: $filter) {
            actionDate
            destination
            details
            duration
            fromCountry
            groupKey
            id
            productCode
            requestorID
            toCountry
            typeKey
            value
          }
        }
      }`, this, 'currentCustomer', {
          filter: this.getFilter()
        }, () => {
          this.$_filterItemisedBills()
          me.loading = false
        }, {},
        () => {
          me.loading = false
        }
      )
    }
  }
}
</script>
